export const A2A_CONTINUATION_QUEUED_MARKER =
  "[agent-native:a2a-continuation-queued]";
